import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lifetime-probability-calculator',
  component: () => import('../../routes/LifetimeProbabilityCalculator.svelte'),
  card: {
    id: 'lifetime-probability-calculator',
    title: 'Lifetime Probability Calculator',
    description: 'Calculate the probability of an event occurring at least once over a lifetime. Enter an annual risk percentage and number of years to see cumulative probability.',
    icon: 'analytics',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/lifetime-probability-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Lifetime Probability Calculator – Cumulative Risk Over Time',
    description: 'Free lifetime probability calculator to estimate the likelihood of an event occurring at least once over a given period. Enter annual probability and years to see cumulative risk.',
  },
};

export default meta;